/**
 * 
 * @param successMessage message to show when succeeded
 * @param failureMessage message to show when failed
 * @param hideSuccessMessageAfter set to 0 to persist
 * @returns
 */
export default function useSubmitFeedback(successMessage: string, failureMessage: string, hideSuccessMessageAfter: number = 3000) {
  const status = ref<number>(0);

  const failed = computed<boolean>(() => status.value < 0);
  const succeeded = computed<boolean>(() => status.value > 0);
  const neutral = computed<boolean>(() => status.value === 0);

  const feedbackMessage = computed<string>(() => {
    if (failed.value) {
      return failureMessage;
    } else if (succeeded.value) {
      return successMessage;
    } else {
      return '';
    }
  });

  const feedbackClass = computed(() => {
    if (failed.value) {
      return 'failed';
    } else if (succeeded.value) {
      return 'success';
    } else {
      return 'neutral';
    }
  })

  /**
   * Set success status by boolean
   * @param success 
   */
  function setStatus(success: boolean) {
    status.value = success ? 1 : -1;
  }

  /**
   * Reset status to 0
   */
  function resetStatus() {
    status.value = 0;
  }

  /**
   * Set status to success and may reset status after given interval
   * 
   * @param persist persist the status instead of removing after set interval
   */
  function handleSuccess(persist = false) {
    setStatus(true);

    if (!persist && hideSuccessMessageAfter) {
      // Rest status after given timeout
      setTimeout(resetStatus, hideSuccessMessageAfter);
    }
  }

  return {
    status,
    failed,
    neutral,
    succeeded,
    feedbackMessage,
    feedbackClass,
    setStatus,
    resetStatus,
    handleSuccess
  }
}
